/* =========================================================
   NOVASCENT — Core theme JS
   Vanilla JS, no build step. Progressive enhancement over
   standard Shopify Ajax API (/cart.js, /cart/add.js, ...).
   ========================================================= */

(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {
    cartAdd: '/cart/add.js',
    cartChange: '/cart/change.js',
    cartUpdate: '/cart/update.js',
    cartGet: '/cart.js',
    root: '/'
  };

  /* ---------------- Utilities ---------------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, evt, sel, handler) {
    if (!el) return;
    el.addEventListener(evt, function (e) {
      var target = e.target.closest(sel);
      if (target && el.contains(target)) handler(e, target);
    });
  }
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var parts = value.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return (format || '{{amount}} €').replace('{{amount}}', parts.join(','));
  }
  /* ---------------- Optimistic cart UI (instant feedback before server confirms) ---------------- */
  function optimisticGetUnitPrice(row) {
    return parseInt((row && row.getAttribute('data-unit-price')) || '0', 10);
  }
  function optimisticSyncOrderTotal(container, pureSubtotalCents) {
    var target = qs('[data-shipping-surcharge-target]', container);
    if (!target) return;
    var checkedSurcharge = container.querySelector('[data-shipping-surcharge]:checked');
    var surcharge = checkedSurcharge ? parseInt(checkedSurcharge.getAttribute('data-shipping-surcharge'), 10) || 0 : 0;
    target.textContent = formatMoney(pureSubtotalCents + surcharge);
  }
  function optimisticRecomputeSubtotal(container) {
    var rows = qsa('[data-unit-price]', container);
    var total = 0;
    rows.forEach(function (row) {
      if (row.classList.contains('is-removing')) return;
      var qtyInput = row.querySelector('input[type="text"], input[type="number"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 0;
      total += optimisticGetUnitPrice(row) * qty;
    });
    qsa('[data-cart-subtotal], [data-cart-preview-subtotal]', container).forEach(function (el) {
      el.textContent = formatMoney(total);
    });
    optimisticSyncOrderTotal(container, total);
    return total;
  }
  function optimisticRecomputeShipping(container, subtotalCents) {
    var bar = qs('[data-shipping-bar]', container);
    var fs = window.theme && window.theme.freeShipping;
    if (!bar || !fs || !fs.enabled) return;
    var remaining = fs.thresholdCents - subtotalCents;
    if (remaining < 0) remaining = 0;
    var progress = fs.thresholdCents > 0 ? Math.min(100, Math.round((subtotalCents / fs.thresholdCents) * 100)) : 100;
    var msgEl = qs('[data-shipping-message]', bar);
    var fillEl = qs('[data-shipping-fill]', bar);
    if (msgEl) {
      msgEl.innerHTML = remaining > 0
        ? fs.messageIncomplete.replace('{{ amount }}', formatMoney(remaining))
        : '<strong>' + fs.messageComplete + '</strong>';
    }
    if (fillEl) fillEl.style.width = progress + '%';
  }
  function optimisticApplyLineChange(container, row, newQuantity) {
    if (!container || !row) return;
    var unitPrice = optimisticGetUnitPrice(row);
    qsa('input[type="text"], input[type="number"]', row).forEach(function (input) { input.value = newQuantity; });
    var lineTotal = unitPrice * newQuantity;
    qsa('[data-line-total], [data-line-total-mobile]', row).forEach(function (el) { el.textContent = formatMoney(lineTotal); });
    if (newQuantity <= 0) {
      row.classList.add('is-removing');
      row.style.transition = 'opacity 200ms ease';
      row.style.opacity = '0.35';
      row.style.pointerEvents = 'none';
    }
    var subtotal = optimisticRecomputeSubtotal(container);
    optimisticRecomputeShipping(container, subtotal);
  }
  function optimisticBumpCartCountBadge(delta) {
    if (!delta) return;
    qsa('[data-cart-count]').forEach(function (el) {
      var next = (parseInt(el.textContent, 10) || 0) + delta;
      el.textContent = next < 0 ? 0 : next;
    });
    qsa('[data-cart-count-bubble]').forEach(function (el) {
      var countEl = qs('[data-cart-count]', el) || el;
      var count = parseInt(countEl.textContent, 10) || 0;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  window.theme = window.theme || {};
  window.theme.formatMoney = formatMoney;

  /* ---------------- Announcement bar slider ---------------- */
  var ROTATOR_TYPE_COLORS = {
    promo: { background: '#DC0069', color: '#FFFFFF' },
    reduction: { background: '#B8004F', color: '#FFFFFF' },
    info: { background: '#000000', color: '#FAF8F5' }
  };

  function initRotators() {
    qsa('[data-rotator]').forEach(function (bar) {
      var track = qs('[data-rotator-track]', bar);
      var items = track ? qsa('.rotator__item', track) : [];
      if (!track || items.length < 2) return;
      var index = 0;
      var interval = parseInt(bar.getAttribute('data-interval') || '5000', 10);
      var syncColor = bar.hasAttribute('data-rotator-color-sync');
      var dots = qsa('[data-rotator-dot]', bar);
      function go(i) {
        var previousIndex = index;
        index = (i + items.length) % items.length;
        if (previousIndex !== index && items[previousIndex]) {
          var leavingItem = items[previousIndex];
          leavingItem.classList.remove('is-active');
          leavingItem.classList.add('is-leaving');
          setTimeout(function () { leavingItem.classList.remove('is-leaving'); }, 500);
        }
        items.forEach(function (item, itemIndex) { item.classList.toggle('is-active', itemIndex === index); });
        dots.forEach(function (dot, dotIndex) { dot.classList.toggle('is-active', dotIndex === index); });
        if (syncColor) {
          var type = items[index].getAttribute('data-type');
          var palette = ROTATOR_TYPE_COLORS[type];
          if (palette) {
            bar.style.backgroundColor = palette.background;
            bar.style.color = palette.color;
          }
        }
      }
      var timer;
      function startTimer() { timer = setInterval(function () { go(index + 1); }, interval); }
      function restartTimer() { clearInterval(timer); startTimer(); }
      on(bar, 'click', '[data-rotator-next]', function () { go(index + 1); restartTimer(); });
      on(bar, 'click', '[data-rotator-prev]', function () { go(index - 1); restartTimer(); });
      on(bar, 'click', '[data-rotator-dot]', function (e, dot) { go(parseInt(dot.getAttribute('data-rotator-dot'), 10)); restartTimer(); });
      go(0);
      startTimer();
    });
  }

  /* ---------------- Header mega menu ---------------- */
  function initMegaMenu() {
    var nav = qs('[data-main-nav]');
    if (!nav) return;
    var items = qsa('.main-nav__item', nav);
    items.forEach(function (item) {
      var trigger = qs('.main-nav__link', item);
      var menu = qs('.mega-menu', item);
      if (!menu) return;
      var closeTimer;
      function open() { clearTimeout(closeTimer); items.forEach(function (i) { i.classList.remove('is-open'); }); item.classList.add('is-open'); }
      function scheduleClose() { closeTimer = setTimeout(function () { item.classList.remove('is-open'); }, 150); }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', scheduleClose);
      trigger.addEventListener('focus', open);
      trigger.addEventListener('click', function (e) {
        if (window.matchMedia('(max-width: 989px)').matches) {
          e.preventDefault();
          item.classList.toggle('is-open');
        }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') items.forEach(function (i) { i.classList.remove('is-open'); });
    });
  }

  /* ---------------- Mobile nav toggle ---------------- */
  function initMobileNav() {
    var nav = qs('[data-main-nav]');
    var overlay = qs('[data-nav-mobile-overlay]');
    if (!nav) return;
    function toggleNav() {
      nav.classList.toggle('is-mobile-open');
      document.body.classList.toggle('nav-open');
      if (overlay) overlay.classList.toggle('is-visible');
    }
    function closeNav() {
      nav.classList.remove('is-mobile-open');
      document.body.classList.remove('nav-open');
      if (overlay) overlay.classList.remove('is-visible');
    }
    qsa('[data-mobile-nav-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', toggleNav);
    });
    if (overlay) overlay.addEventListener('click', closeNav);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });
  }

  /* ---------------- Cart drawer ---------------- */
  var CartDrawer = {
    el: null,
    overlay: null,
    init: function () {
      this.el = qs('[data-cart-drawer]');
      this.overlay = qs('[data-cart-drawer-overlay]');
      if (!this.el) return;
      on(document, 'click', '[data-cart-drawer-open]', function (e) { e.preventDefault(); CartDrawer.open(); });
      on(document, 'click', '[data-cart-drawer-close]', function (e) { e.preventDefault(); CartDrawer.close(); });
      if (this.overlay) this.overlay.addEventListener('click', function () { CartDrawer.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') CartDrawer.close(); });

      on(this.el, 'click', '[data-cart-item-remove]', function (e, target) {
        e.preventDefault();
        CartDrawer.changeItem(target.getAttribute('data-key'), 0);
      });
      on(this.el, 'click', '[data-qty-increase]', function (e, target) {
        e.preventDefault();
        var input = target.parentNode.querySelector('input');
        CartDrawer.changeItem(target.getAttribute('data-key'), parseInt(input.value, 10) + 1);
      });
      on(this.el, 'click', '[data-qty-decrease]', function (e, target) {
        e.preventDefault();
        var input = target.parentNode.querySelector('input');
        var next = parseInt(input.value, 10) - 1;
        CartDrawer.changeItem(target.getAttribute('data-key'), next < 0 ? 0 : next);
      });
    },
    open: function () {
      this.el.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-visible');
      document.body.classList.add('drawer-open');
    },
    close: function () {
      this.el.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-visible');
      document.body.classList.remove('drawer-open');
    },
    changeItem: function (key, quantity) {
      var row = CartDrawer.el ? CartDrawer.el.querySelector('[data-key="' + key + '"]') : null;
      if (row) {
        var qtyInput = row.querySelector('input[type="text"], input[type="number"]');
        var oldQty = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 0;
        optimisticApplyLineChange(CartDrawer.el, row, quantity);
        optimisticBumpCartCountBadge(quantity - oldQty);
      }
      fetch(routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { CartDrawer.refresh(true); });
    },
    refresh: function (openAfter) {
      fetch(window.location.pathname + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var key = Object.keys(data)[0];
          var html = data[key];
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer]');
          if (fresh && CartDrawer.el) {
            CartDrawer.el.innerHTML = fresh.innerHTML;
          }
          updateCartCount();
          restorePromoState();
          if (openAfter) CartDrawer.open();
        })
        .catch(function () { window.location.reload(); });
    }
  };

  var lastCartCount = null;

  function refreshCartPreview() {
    var header = qs('[data-site-header]');
    var sectionId = header && header.getAttribute('data-section-id');
    var preview = qs('[data-cart-preview]');
    if (!header || !sectionId || !preview) return;
    fetch(window.location.pathname + '?sections=' + sectionId)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-preview]');
        if (fresh) preview.innerHTML = fresh.innerHTML;
      });
  }

  function updateCartCount() {
    fetch(routes.cartGet).then(function (r) { return r.json(); }).then(function (cart) {
      qsa('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      qsa('[data-cart-count-bubble]').forEach(function (el) {
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        if (lastCartCount !== null && cart.item_count !== lastCartCount) {
          el.classList.remove('is-updated');
          void el.offsetWidth;
          el.classList.add('is-updated');
          setTimeout(function () { el.classList.remove('is-updated'); }, 260);
        }
      });
      lastCartCount = cart.item_count;
    });
    refreshCartPreview();
  }

  /* ---------------- Add to cart (forms) ---------------- */
  function initProductForms() {
    on(document, 'submit', 'form[data-product-form]', function (e, form) {
      e.preventDefault();
      var btn = qs('[type="submit"]', form);
      var formData = new FormData(form);
      if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
      fetch(routes.cartAdd, { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            showToast(data.description || data.message || 'Une erreur est survenue.');
            return;
          }
          CartDrawer.refresh(true);
        })
        .catch(function () { showToast('Une erreur est survenue.'); })
        .finally(function () {
          if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
        });
    });
  }

  function showToast(message) {
    var toast = qs('[data-cart-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () { toast.classList.remove('is-visible'); }, 3200);
  }

  /* ---------------- Quantity selectors (generic, non-cart-drawer) ---------------- */
  function initQuantitySelectors() {
    on(document, 'click', '[data-qty-plus]', function (e, target) {
      var input = target.parentNode.querySelector('input[type="number"], input[type="text"]');
      if (!input) return;
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    on(document, 'click', '[data-qty-minus]', function (e, target) {
      var input = target.parentNode.querySelector('input[type="number"], input[type="text"]');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 1) - 1;
      input.value = next < 1 ? 1 : next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------------- Cart page line updates ---------------- */
  function cartPageChangeLine(page, line, quantity) {
    var row = page.querySelector('[data-cart-page-item][data-line="' + line + '"]');
    if (row) {
      var qtyInput = row.querySelector('input[type="text"], input[type="number"]');
      var oldQty = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 0;
      optimisticApplyLineChange(page, row, quantity);
      optimisticBumpCartCountBadge(quantity - oldQty);
    }
    fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count === 0) window.location.reload();
        CartDrawer.refresh(false);
      })
      .catch(function () { window.location.reload(); });
  }

  function initCartPage() {
    var page = qs('[data-cart-page]');
    if (!page) return;
    on(page, 'change', 'input[data-line-qty]', function (e, input) {
      cartPageChangeLine(page, input.getAttribute('data-line'), parseInt(input.value, 10) || 0);
    });
    on(page, 'click', '[data-line-remove]', function (e, target) {
      e.preventDefault();
      cartPageChangeLine(page, target.getAttribute('data-line'), 0);
    });
  }

  /* ---------------- Variant picker ---------------- */
  function initVariantPicker() {
    qsa('[data-product-form]').forEach(function (form) {
      var productJsonEl = qs('[data-product-json]', form.closest('[data-product-section]') || document);
      if (!productJsonEl) return;
      var product;
      try { product = JSON.parse(productJsonEl.textContent); } catch (err) { return; }

      function getSelectedOptions() {
        return qsa('input[name="option-value"]:checked, select[name="option-value"]', form).map(function (el) { return el.value; });
      }
      function findVariant(options) {
        return product.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === options[i]; });
        });
      }
      function updateUI() {
        var options = getSelectedOptions();
        var variant = options.length > 0 ? findVariant(options) : product.variants[0];
        var idInput = qs('input[name="id"]', form);
        var priceEl = qs('[data-product-price]', form.closest('[data-product-section]'));
        var submitBtn = qs('[type="submit"]', form);
        var compareEl = qs('[data-product-compare-price]', form.closest('[data-product-section]'));

        qsa('.variant-swatch', form).forEach(function (sw) {
          var input = qs('input', sw);
          var testOptions = options.slice();
          var idx = parseInt(input.getAttribute('data-option-index'), 10);
          testOptions[idx] = input.value;
          var match = findVariant(testOptions);
          input.disabled = !match || !match.available;
        });

        if (!variant) {
          if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = submitBtn.getAttribute('data-unavailable-text') || 'Indisponible'; }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.classList.remove('hide');
          } else {
            compareEl.classList.add('hide');
          }
        }
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          submitBtn.textContent = variant.available
            ? (submitBtn.getAttribute('data-add-text') || 'Ajouter au panier')
            : (submitBtn.getAttribute('data-unavailable-text') || 'Rupture de stock');
        }
        qsa('[data-selected-value]', form).forEach(function (el, i) { el.textContent = options[i] || ''; });

        var stockEl = qs('[data-low-stock-message]', form.closest('[data-product-section]'));
        if (stockEl) {
          var threshold = parseInt(stockEl.getAttribute('data-low-stock-threshold') || '10', 10);
          var isLow = variant.inventory_management === 'shopify' && variant.inventory_policy &&
            variant.inventory_quantity > 0 && variant.inventory_quantity <= threshold;
          stockEl.classList.toggle('hide', !isLow);
          if (isLow) {
            var stockText = qs('[data-low-stock-text]', stockEl);
            if (stockText) stockText.textContent = 'Plus que ' + variant.inventory_quantity + ' en stock — commandez avant la prochaine rupture';
          }
        }

        var media = variant.featured_media;
        if (media) {
          var galleryImg = qs('.product-gallery__slide[data-media-id="' + media.id + '"]');
          if (galleryImg) {
            var slides = qsa('.product-gallery__slide', galleryImg.closest('.product-gallery__slides'));
            slides.forEach(function (s) { s.classList.remove('is-active'); });
            galleryImg.classList.add('is-active');
            var thumb = qs('.product-gallery__thumb[data-media-id="' + media.id + '"]');
            if (thumb) {
              qsa('.product-gallery__thumb', thumb.closest('.product-gallery__thumbs')).forEach(function (t) { t.classList.remove('is-active'); });
              thumb.classList.add('is-active');
            }
          }
        }
      }
      form.addEventListener('change', function (e) {
        if (e.target.name === 'option-value') updateUI();
      });
      updateUI();
    });
  }

  /* ---------------- Product gallery ---------------- */
  function initGallery() {
    qsa('.product-gallery').forEach(function (gallery) {
      var thumbsTrack = qs('[data-gallery-thumbs]', gallery);
      var dragged = false;

      on(gallery, 'click', '.product-gallery__thumb', function (e, thumb) {
        if (dragged) { dragged = false; return; }
        e.preventDefault();
        var mediaId = thumb.getAttribute('data-media-id');
        qsa('.product-gallery__thumb', gallery).forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        qsa('.product-gallery__slide', gallery).forEach(function (s) {
          s.classList.toggle('is-active', s.getAttribute('data-media-id') === mediaId);
        });
      });

      if (!thumbsTrack) return;
      var isDown = false;
      var startPos = 0;
      var startScroll = 0;
      var isRow = function () { return window.matchMedia('(max-width: 989px)').matches; };

      thumbsTrack.addEventListener('pointerdown', function (e) {
        isDown = true;
        dragged = false;
        startPos = isRow() ? e.clientX : e.clientY;
        startScroll = isRow() ? thumbsTrack.scrollLeft : thumbsTrack.scrollTop;
        thumbsTrack.classList.add('is-dragging');
      });
      thumbsTrack.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var pos = isRow() ? e.clientX : e.clientY;
        var delta = pos - startPos;
        if (Math.abs(delta) > 4) dragged = true;
        if (isRow()) thumbsTrack.scrollLeft = startScroll - delta;
        else thumbsTrack.scrollTop = startScroll - delta;
      });
      function endDrag() { isDown = false; thumbsTrack.classList.remove('is-dragging'); }
      thumbsTrack.addEventListener('pointerup', endDrag);
      thumbsTrack.addEventListener('pointerleave', endDrag);
    });
  }

  /* ---------------- Accordion ---------------- */
  function initAccordion() {
    on(document, 'click', '[data-accordion-trigger]', function (e, trigger) {
      var item = trigger.closest('.accordion__item');
      var panel = qs('.accordion__panel', item);
      var isOpen = item.classList.contains('is-open');
      item.parentNode.querySelectorAll('.accordion__item').forEach(function (i) {
        i.classList.remove('is-open');
        qs('.accordion__panel', i).style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  }

  /* ---------------- Facets (collection filters) ---------------- */
  function initFacets() {
    var overlay = qs('[data-filter-panel-overlay]');

    function closeAllPanels() {
      qsa('.filter-panel.is-open').forEach(function (p) { p.classList.remove('is-open'); });
      qsa('.filter-bar__btn.is-open').forEach(function (b) { b.classList.remove('is-open'); });
      if (overlay) overlay.classList.remove('is-visible');
      document.body.classList.remove('filter-panel-open');
    }

    on(document, 'click', '[data-filter-open]', function (e, trigger) {
      var targetId = trigger.getAttribute('data-filter-open');
      var panel = qs('[data-filter-panel="' + targetId + '"]');
      if (!panel) return;
      var alreadyOpen = panel.classList.contains('is-open');
      closeAllPanels();
      if (!alreadyOpen) {
        panel.classList.add('is-open');
        trigger.classList.add('is-open');
        if (overlay) overlay.classList.add('is-visible');
        document.body.classList.add('filter-panel-open');
        var search = qs('[data-filter-search]', panel);
        if (search) search.focus();
      }
    });

    on(document, 'click', '[data-filter-panel-close]', function () { closeAllPanels(); });
    if (overlay) overlay.addEventListener('click', closeAllPanels);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllPanels(); });

    on(document, 'input', '[data-filter-search]', function (e, input) {
      var panel = input.closest('.filter-panel');
      var query = input.value.trim().toLowerCase();
      var rows = qsa('[data-filter-option-row]', panel);
      var visibleCount = 0;
      rows.forEach(function (row) {
        var label = row.getAttribute('data-filter-option-label') || '';
        var match = label.indexOf(query) !== -1;
        row.classList.toggle('hide', !match);
        if (match) visibleCount += 1;
      });
      var noResults = qs('[data-filter-no-results]', panel);
      if (noResults) noResults.classList.toggle('hide', visibleCount !== 0);
    });

    var form = qs('[data-facets-form]');
    if (form) {
      qsa('input[type="checkbox"], input[type="radio"]', form).forEach(function (input) {
        input.addEventListener('change', function () { form.submit(); });
      });
    }
    var sortSelect = qs('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }
  }

  /* ---------------- Newsletter form (ajax) ---------------- */
  function initNewsletter() {
    qsa('[data-newsletter-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var successEl = qs('[data-newsletter-success]', form.parentNode);
        if (form.querySelector('input[name="contact[email]"]') && successEl) {
          setTimeout(function () {
            form.classList.add('hide');
            successEl.classList.remove('hide');
          }, 50);
        }
      });
    });
  }

  /* ---------------- Header scroll shadow ---------------- */
  function initHeaderScroll() {
    var header = qs('[data-site-header]');
    if (!header) return;
    var lastScroll = 0;
    window.addEventListener('scroll', function () {
      var current = window.scrollY;
      header.classList.toggle('is-scrolled', current > 8);
      lastScroll = current;
    }, { passive: true });
  }

  /* ---------------- Generic slider (hero, product tabs) ---------------- */
  function initSliders() {
    qsa('[data-slider]').forEach(function (root) {
      var track = qs('[data-slider-track]', root);
      var slides = qsa('[data-slider-slide]', root);
      if (!track || slides.length < 2) return;
      var index = 0;
      var isPeek = root.classList.contains('product-slider');

      function slideMetrics() {
        var slideEl = slides[0];
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
        return { width: slideEl.getBoundingClientRect().width, gap: gap };
      }
      function maxIndex() {
        if (!isPeek) return slides.length - 1;
        var metrics = slideMetrics();
        var perView = Math.max(1, Math.round(root.clientWidth / (metrics.width + metrics.gap)));
        return Math.max(0, slides.length - perView);
      }
      function go(i) {
        var max = maxIndex();
        index = i < 0 ? 0 : (i > max ? max : i);
        if (isPeek) {
          var metrics = slideMetrics();
          track.style.transform = 'translateX(-' + (index * (metrics.width + metrics.gap)) + 'px)';
        } else {
          track.style.transform = 'translateX(-' + (index * 100) + '%)';
        }
        qsa('[data-slider-dot]', root).forEach(function (dot, i2) { dot.classList.toggle('is-active', i2 === index); });
      }
      on(root, 'click', '[data-slider-next]', function (e) { e.preventDefault(); go(index + 1); });
      on(root, 'click', '[data-slider-prev]', function (e) { e.preventDefault(); go(index - 1); });
      on(root, 'click', '[data-slider-dot]', function (e, dot) { go(parseInt(dot.getAttribute('data-slider-dot'), 10)); });

      var startX = null;
      var touchDragged = false;
      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        touchDragged = false;
      }, { passive: true });
      track.addEventListener('touchmove', function (e) {
        if (startX === null) return;
        if (Math.abs(e.touches[0].clientX - startX) > 10) touchDragged = true;
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var delta = e.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 40) go(delta < 0 ? index + 1 : index - 1);
        startX = null;
      });
      track.addEventListener('click', function (e) {
        if (touchDragged) { e.preventDefault(); e.stopPropagation(); touchDragged = false; }
      }, true);

      window.addEventListener('resize', function () { go(index); });

      if (!isPeek && root.hasAttribute('data-slider-autoplay')) {
        var interval = parseInt(root.getAttribute('data-slider-autoplay') || '6000', 10);
        setInterval(function () { go(index + 1 > slides.length - 1 ? 0 : index + 1); }, interval);
      }
      go(0);
    });
  }

  /* ---------------- Product tabs (Bestsellers / Nouveautés) ---------------- */
  function initProductTabs() {
    qsa('[data-product-tabs]').forEach(function (root) {
      on(root, 'click', '[data-tab-trigger]', function (e, trigger) {
        var target = trigger.getAttribute('data-tab-trigger');
        qsa('[data-tab-trigger]', root).forEach(function (t) { t.classList.remove('is-active'); });
        qsa('[data-tab-panel]', root).forEach(function (p) { p.classList.remove('is-active'); });
        trigger.classList.add('is-active');
        var panel = qs('[data-tab-panel="' + target + '"]', root);
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  /* ---------------- Footer accordions (mobile) ---------------- */
  function initFooterAccordions() {
    if (window.matchMedia('(max-width: 749px)').matches) {
      qsa('.footer-block').forEach(function (block) { block.classList.add('is-collapsed'); });
    }
    on(document, 'click', '[data-footer-accordion-trigger]', function (e, trigger) {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      trigger.closest('.footer-block').classList.toggle('is-collapsed');
    });
  }

  /* ---------------- Country / currency selector ---------------- */
  function initLocaleForms() {
    qsa('[data-locale-form]').forEach(function (form) {
      qsa('select', form).forEach(function (select) {
        select.addEventListener('change', function () { form.submit(); });
      });
    });
  }

  /* ---------------- Genre filter (classic tag-path, works without Search & Discovery) ---------------- */
  function initGenreFilter() {
    var panel = qs('[data-genre-panel]');
    if (!panel) return;
    var baseUrl = panel.getAttribute('data-base-url');

    function buildUrl(tags) {
      var url = baseUrl;
      if (tags.length > 0) url += '/' + tags.join('+');
      return url + window.location.search;
    }
    function checkedGenres() {
      return qsa('[data-genre-checkbox]', panel).filter(function (cb) { return cb.checked; }).map(function (cb) { return cb.value; });
    }

    on(panel, 'change', '[data-genre-checkbox]', function () {
      window.location.href = buildUrl(checkedGenres());
    });

    on(document, 'click', '[data-genre-remove-pill]', function (e, pill) {
      e.preventDefault();
      var tagToRemove = pill.getAttribute('data-genre-remove-pill');
      var remaining = checkedGenres().filter(function (tag) { return tag !== tagToRemove; });
      window.location.href = buildUrl(remaining);
    });

    on(document, 'click', '[data-price-remove-pill]', function (e, pill) {
      e.preventDefault();
      var params = new URLSearchParams(window.location.search);
      params.delete(pill.getAttribute('data-param-min'));
      params.delete(pill.getAttribute('data-param-max'));
      var query = params.toString();
      window.location.href = window.location.pathname + (query ? '?' + query : '');
    });
  }

  /* ---------------- Cart drawer order note ---------------- */
  function initCartNote() {
    on(document, 'click', '[data-cart-note-toggle]', function (e, trigger) {
      var field = trigger.parentNode.querySelector('[data-cart-note-field]');
      if (!field) return;
      field.classList.toggle('hide');
      trigger.setAttribute('aria-expanded', !field.classList.contains('hide'));
      if (!field.classList.contains('hide')) field.focus();
    });
    var saveTimer;
    on(document, 'change', '[data-cart-note-field]', function (e, field) {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(function () {
        fetch(routes.cartUpdate, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: field.value })
        });
      }, 300);
    });
  }

  /* ---------------- Promo code + auto-apply at checkout ---------------- */
  var PROMO_CODE_KEY = 'novascentPromoCode';
  var PROMO_AUTO_KEY = 'novascentPromoAuto';

  function restorePromoState() {
    var input = qs('[data-promo-code-input]');
    var checkbox = qs('[data-promo-auto-apply]');
    if (input) input.value = sessionStorage.getItem(PROMO_CODE_KEY) || '';
    if (checkbox) checkbox.checked = sessionStorage.getItem(PROMO_AUTO_KEY) === '1';
  }

  function initPromoCode() {
    restorePromoState();
    on(document, 'input', '[data-promo-code-input]', function (e, input) {
      sessionStorage.setItem(PROMO_CODE_KEY, input.value.trim());
    });
    on(document, 'change', '[data-promo-auto-apply]', function (e, checkbox) {
      sessionStorage.setItem(PROMO_AUTO_KEY, checkbox.checked ? '1' : '0');
    });
    on(document, 'submit', '[data-cart-checkout-form]', function (e, form) {
      var code = (sessionStorage.getItem(PROMO_CODE_KEY) || '').trim();
      var autoApply = sessionStorage.getItem(PROMO_AUTO_KEY) === '1';
      if (autoApply && code) {
        e.preventDefault();
        window.location.href = routes.root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout');
      }
    });
  }

  /* ---------------- Collection: "Voir plus de produits" (AJAX load more) ---------------- */
  function initLoadMore() {
    on(document, 'click', '[data-load-more]', function (e, btn) {
      var url = btn.getAttribute('data-next-url');
      var sectionId = btn.getAttribute('data-section-id');
      if (!url || !sectionId) return;
      var grid = qs('[data-product-grid]');
      var separator = url.indexOf('?') > -1 ? '&' : '?';
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-loading-text') || 'Chargement...';
      fetch(url + separator + 'section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-product-grid]');
          var newButton = doc.querySelector('[data-load-more]');
          if (newGrid && grid) {
            Array.prototype.slice.call(newGrid.children).forEach(function (child) {
              grid.appendChild(child);
            });
          }
          if (newButton) {
            btn.setAttribute('data-next-url', newButton.getAttribute('data-next-url'));
            btn.disabled = false;
            btn.textContent = btn.getAttribute('data-default-text') || 'Voir plus de produits';
          } else {
            btn.remove();
          }
        })
        .catch(function () { window.location.href = url; });
    });
  }

  /* ---------------- Product card tap preview (touch devices) ---------------- */
/* ---------------- Product delivery estimate ---------------- */
  function addBusinessDays(date, days) {
    var result = new Date(date);
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return result;
  }
  function formatFrDate(date) {
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });
  }
  function initDeliveryEstimate() {
    qsa('[data-delivery-estimate]').forEach(function (el) {
      var minDays = parseInt(el.getAttribute('data-min-days') || '2', 10);
      var maxDays = parseInt(el.getAttribute('data-max-days') || '4', 10);
      var today = new Date();
      var start = addBusinessDays(today, minDays);
      var end = addBusinessDays(today, maxDays);
      el.textContent = 'Livraison estimée entre le ' + formatFrDate(start) + ' et le ' + formatFrDate(end);
    });
  }

  /* ---------------- Generic collapsible (cart page note / promo panels) ---------------- */
  function initCollapsibles() {
    on(document, 'click', '[data-collapsible-trigger]', function (e, trigger) {
      var panel = trigger.parentNode.querySelector('[data-collapsible-panel]');
      if (!panel) return;
      var isHidden = panel.classList.toggle('hide');
      trigger.setAttribute('aria-expanded', !isHidden);
    });
  }

  /* ---------------- Cart attributes (gift wrap, samples, shipping choice) ---------------- */
  /* ---------------- Cart preview: inline qty/remove controls ---------------- */
  function previewChangeLine(key, quantity) {
    var preview = qs('[data-cart-preview]');
    var row = preview ? preview.querySelector('[data-cart-preview-item][data-key="' + key + '"]') : null;
    if (row && preview) {
      var qtyInput = row.querySelector('input[type="text"], input[type="number"]');
      var oldQty = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 0;
      optimisticApplyLineChange(preview, row, quantity);
      optimisticBumpCartCountBadge(quantity - oldQty);
    }
    fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        updateCartCount();
        CartDrawer.refresh(false);
      });
  }
  function initCartPreviewControls() {
    on(document, 'click', '[data-preview-qty-increase]', function (e, btn) {
      e.preventDefault();
      var input = btn.parentNode.querySelector('input');
      previewChangeLine(btn.getAttribute('data-key'), parseInt(input.value, 10) + 1);
    });
    on(document, 'click', '[data-preview-qty-decrease]', function (e, btn) {
      e.preventDefault();
      var input = btn.parentNode.querySelector('input');
      var next = parseInt(input.value, 10) - 1;
      previewChangeLine(btn.getAttribute('data-key'), next < 0 ? 0 : next);
    });
    on(document, 'click', '[data-preview-item-remove]', function (e, btn) {
      e.preventDefault();
      previewChangeLine(btn.getAttribute('data-key'), 0);
    });
  }

  /* ---------------- Shipping choice: surcharge reflected in cart total ---------------- */
  function initShippingSurcharge() {
    on(document, 'change', '[data-shipping-surcharge]', function (e, radio) {
      var container = radio.closest('[data-cart-page], [data-cart-drawer], [data-cart-preview]') || document;
      var isFlash = radio.value.indexOf('Flash') === 0;
      var flashVariantId = radio.getAttribute('data-flash-variant-id');

      if (isFlash && !flashVariantId) {
        // No real "Flash surcharge" product configured in the section settings yet:
        // we cannot actually charge the +4,95€, so don't show a fake total either.
        console.warn('[Novascent] Aucun produit "Supplément Flash" configuré dans les réglages de la section Panier — le supplément ne peut pas être facturé tant que ce produit n\'est pas créé et sélectionné.');
        var subtotalOnly = optimisticRecomputeSubtotal(container);
        var totalTarget = qs('[data-shipping-surcharge-target]', container);
        if (totalTarget) totalTarget.textContent = formatMoney(subtotalOnly);
        return;
      }

      var pureSubtotal = optimisticRecomputeSubtotal(container);
      optimisticSyncOrderTotal(container, pureSubtotal);

      if (!flashVariantId) return;
      if (isFlash) {
        fetch(routes.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: flashVariantId, quantity: 1 })
        }).then(function () { updateCartCount(); CartDrawer.refresh(false); });
      } else {
        fetch(routes.cartChange, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: flashVariantId, quantity: 0 })
        }).then(function () { updateCartCount(); CartDrawer.refresh(false); });
      }
    });
  }

  function initCartAttributes() {
    on(document, 'change', '[data-cart-attribute]', function (e, input) {
      var key = input.getAttribute('data-cart-attribute');
      var value = input.type === 'checkbox' ? (input.checked ? (input.getAttribute('data-value-on') || 'Oui') : '') : input.value;
      var attributes = {};
      attributes[key] = value;
      fetch(routes.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      });
    });
  }

  /* ---------------- Chat Alfred: local keyword-based assistant ---------------- */
  /* 100% client-side rule matching — no external API, no network call, no cost. */
  var ALFRED_TOPICS = [
    {
      keywords: ['bonjour', 'salut', 'coucou', 'hello', 'bonsoir', 'bonne journee'],
      response: "Bonjour ! Je suis Alfred, votre assistant Novascent. Comment puis-je vous aider aujourd'hui ?"
    },
    {
      keywords: ['authentique', 'original', 'faux', 'contrefacon', 'garanti'],
      response: "Tous nos parfums sont 100% authentiques : ils proviennent directement des marques ou de distributeurs agréés, et chaque commande est contrôlée avant expédition."
    },
    {
      keywords: ['livraison', 'colis', 'delai', 'expedition', 'delais'],
      response: "Nous expédions sous 24 à 48h. La livraison standard est offerte dès 80€ d'achat, et vous recevez un e-mail de suivi dès l'envoi de votre colis."
    },
    {
      keywords: ['commande', 'suivi', 'ou est', 'arrive', 'statut', 'tracking'],
      response: "Pour suivre votre commande, connectez-vous à votre compte puis rendez-vous dans \"Mes commandes\" : vous y trouverez le statut et le numéro de suivi."
    },
    {
      keywords: ['retour', 'rembours', 'echange', 'annuler'],
      response: "Vous disposez de 30 jours après réception pour retourner un article non ouvert. Le remboursement est effectué sous 5 à 7 jours ouvrés après réception du retour."
    },
    {
      keywords: ['code promo', 'reduction', 'promo', 'coupon'],
      response: "Vous pouvez saisir votre code promo dans le champ dédié du panier, puis cocher la case \"Appliquer automatiquement mon code au paiement\" pour qu'il soit pris en compte au checkout."
    },
    {
      keywords: ['cadeau', 'offrir', 'emballage'],
      response: "Excellente idée ! Nous proposons un emballage cadeau offert (cochez l'option dans votre panier) et un large choix de coffrets. Consultez nos collections pour trouver l'idée parfaite."
    },
    {
      keywords: ['paiement', 'carte bancaire', 'payer', '3x', 'paypal', 'virement'],
      response: "Nous acceptons la carte bancaire, PayPal et le paiement en plusieurs fois sans frais. Toutes les transactions sont sécurisées de bout en bout."
    },
    {
      keywords: ['humain', 'conseiller', 'service client', 'parler a quelqu'],
      response: "Bien sûr, je vous mets en relation avec notre équipe.",
      action: 'contact'
    }
  ];
  var ALFRED_SUGGESTIONS = [
    'Je cherche un cadeau',
    "Ma commande n'est pas arrivée",
    'Les parfums sont-ils authentiques ?',
    'Comment utiliser un code promo ?'
  ];
  var ALFRED_FALLBACK = "Je n'ai pas bien compris votre question. Voici quelques sujets sur lesquels je peux vous aider :";

  var ALFRED_ACCENTS = { 'à': 'a', 'â': 'a', 'ä': 'a', 'é': 'e', 'è': 'e', 'ê': 'e', 'ë': 'e', 'î': 'i', 'ï': 'i', 'ô': 'o', 'ö': 'o', 'ù': 'u', 'û': 'u', 'ü': 'u', 'ç': 'c', 'œ': 'oe' };
  function alfredNormalize(str) {
    var result = str.toLowerCase();
    for (var key in ALFRED_ACCENTS) {
      result = result.split(key).join(ALFRED_ACCENTS[key]);
    }
    return result;
  }
  function alfredMatch(text) {
    var normalized = alfredNormalize(text);
    for (var i = 0; i < ALFRED_TOPICS.length; i++) {
      var topic = ALFRED_TOPICS[i];
      for (var j = 0; j < topic.keywords.length; j++) {
        if (normalized.indexOf(alfredNormalize(topic.keywords[j])) !== -1) return topic;
      }
    }
    return null;
  }
  function alfredAppendMessage(container, text, sender) {
    var el = document.createElement('div');
    el.className = 'chat-message chat-message--' + sender;
    var p = document.createElement('p');
    p.textContent = text;
    el.appendChild(p);
    container.appendChild(el);
    container.scrollTop = container.scrollHeight;
    return el;
  }
  function alfredAppendSuggestions(container) {
    var wrap = document.createElement('div');
    wrap.className = 'chat-message chat-message--bot chat-message--suggestions';
    ALFRED_SUGGESTIONS.forEach(function (q) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'chat-quick-reply';
      btn.setAttribute('data-chat-question', q);
      btn.textContent = q;
      wrap.appendChild(btn);
    });
    container.appendChild(wrap);
    container.scrollTop = container.scrollHeight;
  }
  function alfredHandleQuestion(bubble, question) {
    var messages = qs('[data-chat-messages]', bubble);
    if (!messages) return;
    alfredAppendMessage(messages, question, 'user');
    var topic = alfredMatch(question);
    setTimeout(function () {
      if (topic) {
        var botEl = alfredAppendMessage(messages, topic.response, 'bot');
        if (topic.action === 'contact') {
          var switchBtn = document.createElement('button');
          switchBtn.type = 'button';
          switchBtn.className = 'chat-quick-reply';
          switchBtn.setAttribute('data-chat-open-contact', '');
          switchBtn.style.marginTop = '0.5rem';
          switchBtn.textContent = 'Ouvrir le formulaire de contact';
          botEl.appendChild(document.createElement('br'));
          botEl.appendChild(switchBtn);
        }
      } else {
        alfredAppendMessage(messages, ALFRED_FALLBACK, 'bot');
        alfredAppendSuggestions(messages);
      }
    }, 250);
  }
  function initChatAlfred() {
    var bubble = qs('[data-chat-bubble]');
    if (!bubble) return;
    on(bubble, 'click', '[data-chat-question]', function (e, btn) {
      alfredHandleQuestion(bubble, btn.getAttribute('data-chat-question'));
    });
    on(bubble, 'submit', '[data-chat-input-form]', function (e, form) {
      e.preventDefault();
      var input = qs('[data-chat-input]', form);
      var value = input.value.trim();
      if (!value) return;
      alfredHandleQuestion(bubble, value);
      input.value = '';
    });
    on(bubble, 'click', '[data-chat-open-contact]', function () {
      var conversation = qs('[data-chat-view="conversation"]', bubble);
      var contact = qs('[data-chat-view="contact"]', bubble);
      if (conversation) conversation.classList.add('hide');
      if (contact) contact.classList.remove('hide');
    });
    on(bubble, 'click', '[data-chat-back-to-conversation]', function () {
      var conversation = qs('[data-chat-view="conversation"]', bubble);
      var contact = qs('[data-chat-view="contact"]', bubble);
      if (contact) contact.classList.add('hide');
      if (conversation) conversation.classList.remove('hide');
    });
  }

  /* ---------------- Support chat bubble ---------------- */
  function initChatBubble() {
    var bubble = qs('[data-chat-bubble]');
    if (!bubble) return;
    function open() { bubble.classList.add('is-open'); }
    function close() { bubble.classList.remove('is-open'); }
    on(document, 'click', '[data-chat-toggle]', function (e, trigger) {
      if (bubble.contains(trigger)) {
        bubble.classList.toggle('is-open');
      } else {
        open();
      }
    });
    on(document, 'click', '[data-chat-close]', function () { close(); });
    document.addEventListener('click', function (e) {
      if (bubble.classList.contains('is-open') && !bubble.contains(e.target) && !e.target.closest('[data-chat-toggle]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------------- Video testimonial carousel (mobile arrows) ---------------- */
  function initTestimonialCarousel() {
    qsa('[data-testimonial-carousel]').forEach(function (root) {
      var track = qs('[data-testimonial-track]', root);
      if (!track) return;
      function cardStep() {
        var card = qs('.testimonial-card', track);
        if (!card) return 240;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      on(root, 'click', '[data-testimonial-prev]', function () { track.scrollBy({ left: -cardStep(), behavior: 'smooth' }); });
      on(root, 'click', '[data-testimonial-next]', function () { track.scrollBy({ left: cardStep(), behavior: 'smooth' }); });
    });
  }

  /* ---------------- Arrival popup (once per session) ---------------- */
  function initArrivalPopup() {
    var popup = qs('[data-arrival-popup]');
    if (!popup) return;
    var SESSION_KEY = 'novascent_arrival_popup_shown';
    if (sessionStorage.getItem(SESSION_KEY)) return;
    function close() {
      popup.classList.remove('is-open');
      sessionStorage.setItem(SESSION_KEY, '1');
    }
    on(popup, 'click', '[data-arrival-popup-close]', close);
    on(popup, 'click', '[data-arrival-popup-overlay]', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
    });
    var delay = parseInt(popup.getAttribute('data-popup-delay') || '2000', 10);
    setTimeout(function () { popup.classList.add('is-open'); }, delay);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initRotators();
    initMegaMenu();
    initMobileNav();
    CartDrawer.init();
    initProductForms();
    initQuantitySelectors();
    initCartPage();
    initVariantPicker();
    initGallery();
    initAccordion();
    initFacets();
    initGenreFilter();
    initNewsletter();
    initHeaderScroll();
    initSliders();
    initProductTabs();
    initFooterAccordions();
    initLocaleForms();
    initCartNote();
    initPromoCode();
    initCollapsibles();
    initCartAttributes();
    initShippingSurcharge();
    initCartPreviewControls();
    initChatBubble();
    initTestimonialCarousel();
    initArrivalPopup();
    initChatAlfred();
    initDeliveryEstimate();
    initLoadMore();
    updateCartCount();
  });
})();
